import React, { useEffect, useMemo, useState } from "react";
import "../../../src/style.css";
import {
  Button,
  createTheme,
  ThemeProvider,
  Typography,
} from "@mui/material";
import {
  GridToolbar,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import { getAdminCallActive } from "../../redux/actions/adminPortal_callActiveAction";
import { useDispatch, useSelector } from "react-redux";
import PhoneDisabledIcon from "@mui/icons-material/PhoneDisabled";
import { api } from "../../mockData";
import axios from "axios";
import { toast } from "react-toastify";
import { StyledDataGrid } from "../../pages/CustomDataGrid";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import dayjs from "dayjs";
import ActiveTable from "./ActiveTable";
import { Table } from "react-bootstrap";
import PageTitle from "../../components/common/PageTitle";

const theme = createTheme({
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-row": {
            minHeight: "auto",
          },
        },
      },
      defaultProps: {
        density: "compact",
      },
    },
  },
});

export function CustomFooterStatusComponent(props) {
  return <></>;
}

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
      <GridToolbarFilterButton />
    </GridToolbarContainer>
  );
}

function CallActive({ userThem }) {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
    const [timeDifference, setTimeDifference] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  const current_user = localStorage.getItem("current_user");
  const user = JSON.parse(localStorage.getItem(`user_${current_user}`));

  // useEffect(() => {
  dispatch(getAdminCallActive());
  // }, [dispatch]);

  const mockDataTeam = useMemo(() => {
    if (state?.getAdminCallActive?.callactive !== undefined) {
      const parsedData = Object.keys(state?.getAdminCallActive?.callactive)
        .map((key) => {
          try {
            const parsedValue = JSON.parse(
              state?.getAdminCallActive?.callactive[key],
            );
            return {
              id: key,
              ...parsedValue,
            };
          } catch (error) {
            console.error(`Failed to parse JSON for key: ${key}`, error);
            return null;
          }
        })
        .filter(Boolean)
        .filter((row) => row.UserId === user.uid)
        .sort((a, b) => {
          const dateA = dayjs(a.TimeStamp);
          const dateB = dayjs(b.TimeStamp);
          return dateB - dateA;
        });

      return parsedData;
    }
    return [];
  }, [state?.getAdminCallActive?.callactive, user.uid]);

  // Function to calculate time differences for each timestamp
  const calculateTimeDifferences = () => {
    const now = new Date();
    const diffMap = {};

    mockDataTeam.forEach((row) => {
      const ts = new Date(row.TimeStamp);
      const diff = now - ts;
      const sec = Math.floor(diff / 1000);
      const min = Math.floor(sec / 60);
      const hr = Math.floor(min / 60);

      diffMap[row.id] = {
        hours: String(hr).padStart(2, "0"),
        minutes: String(min % 60).padStart(2, "0"),
        seconds: String(sec % 60).padStart(2, "0"),
      };
    });

    setTimeDifference(diffMap);
  };

  // Calculate time differences initially and update every second
  useEffect(() => {
    if (mockDataTeam.length > 0) {
      calculateTimeDifferences();
    }

    const interval = setInterval(() => {
      if (mockDataTeam.length > 0) {
        calculateTimeDifferences();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [mockDataTeam]); // Removed timeStamp dependency to fix the issue



  const handleHangup = async (data) => {
    const current_user = localStorage.getItem("current_user");
    const token = JSON.parse(localStorage.getItem(`user_${current_user}`));
    let values = JSON.stringify({
      CallReference: data.CallReference,
    });
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.access_token} `,
        },
      };
      const { data } = await axios.post(
        `${api.dev}/api/callhangup`,
        values,
        config,
      );
      if (data?.status === 200) {
        toast.success(data?.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
        });
      } else {
        toast.error(data?.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2500,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2500,
      });
    }
  };

  // Responsive breakpoints
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.between("sm"));

  // All Columns Data
  const allColumns = [
    {
      field: "DIDNumber",
      headerName: "Did Number",
      headerClassName: "custom-header",
      flex: 1,
      minWidth: 140,    
      headerAlign: "left",
      disableColumnMenu: true,
      sortable: true,
      align: "left",
    },
    {
      field: "CallerID",
      headerName: "Caller Id",
      headerClassName: "custom-header",
      flex: 1,
      minWidth: 140,
      headerAlign: "left",
      disableColumnMenu: true,
      sortable: true,
      align: "left",
    },
    {
      field: "CompaignName",
      headerName: "Campaign Name",
      flex:1,
      minWidth: 100,
      
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "center",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          {isSmallScreen ? "Camp. Name" : "Campaign Name"}
        </Typography>
      ),
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.6rem + 0.2vw)" }}
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "BuyerName",
      headerName: "Buyer Name",
      headerClassName: "custom-header",

      minWidth: 120,
      flex: 1,      
      headerAlign: "left",
      disableColumnMenu: true,
      align: "left",
    },
    {
      field: "ForwardedTo",
      headerName: "Forwarded To",
      headerClassName: "custom-header",
      flex: 1,
      minWidth: 120,
      
      headerAlign: "left",
      disableColumnMenu: true,
      sortable: true,
      align: "left",
    },
    {
      field: "Status",
      headerName: "Status",
      headerClassName: "custom-header",
      flex: 1,
      minWidth: 200,
      
      headerAlign: "left",
      disableColumnMenu: true,
      sortable: true,
      align: "left",
      renderCell: (params) => {
        let color = "black";
        if (params.value === "ANSWER") color = "green";
        else if (params.value === "DIALING") color = "violet";
        else if (params.value === "RINGING") color = "skyblue";

        return (
          <span style={{ fontWeight: "500", color }}>
            {params.value}
          </span>
        );
      },
    },
    {
      field: "CallDuration",
      headerName: "Call Duration",
      headerClassName: "custom-header",
      flex: 1,
      minWidth: 130,
      sortable: false,
      renderCell: (params) => {
        const duration = timeDifference[params.row.id];

        if (!duration) return "00:00:00";

        if (params.row.Status === "DIALING") {
          return <span style={{ color: "grey" }}>00:00:00</span>;
        }

        return (
          <span style={{ color: "green", fontWeight: 600 }}>
            {duration.hours}:{duration.minutes}:{duration.seconds}
          </span>
        );
      },
    },
    {
      field: "TimeStamp",
      headerName: "Date Time",
      headerClassName: "custom-header",
      flex: 1,
      minWidth: 170,      
      headerAlign: "left",
      disableColumnMenu: true,
      sortable: true,
      align: "left",
      renderCell: (params) => {
        if (params.value !== null) {
          const date = new Date(params.value);
          const day = String(date.getUTCDate()).padStart(2, "0");
          const month = String(date.getUTCMonth() + 1).padStart(2, "0");
          const year = date.getUTCFullYear();
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");

          return (
            <>
              <span style={{ color: "blue" }}>
                {day}/{month}/{year}
              </span>
              &nbsp;
              <span style={{ color: "green" }}>
                {hours}:{minutes}:{seconds}
              </span>
            </>
          );
        }
        return null;
      },
    },
  ];


    const columns1 = [
    { key: "sno", label: "S.No", textAlign: "center", sortable: false },    
    { key: "DIDNumber", label: "Did Number", sortable: true },
    { key: "CallerID", label: "Caller id", sortable: true },
    { key: "CompaignName", label: "Campaign Name", sortable: true },
    { key: "BuyerName", label: "Buyer Name", width: 180, minWidth: 150,sortable: true,},
    { key: "ForwardedTo", label: "Forwarded To", sortable: true },
     { key: "Status", label: "Status", sortable: true },
        {
      key: "CallDuration",
      label: "Call Duration",
      width: 130,
      textAlign: "center",
      sortable: true,
    },
    { key: "TimeStamp", label: "Date Time", sortable: true },
    { key: "hangup", label: "Hangup", textAlign: "center", sortable: false },
  ];

  // ---------------- Sorting ------------------
   // ---------------- Sorting ------------------
   const handleSort = (columnKey) => {
     const column = columns1.find((col) => col.key === columnKey);
     if (!column?.sortable) return; // Don't sort if column is not sortable
 
     if (sortConfig.key === columnKey) {
       if (sortConfig.direction === "asc") {
         setSortConfig({ key: columnKey, direction: "desc" });
       } else if (sortConfig.direction === "desc") {
         setSortConfig({ key: null, direction: null });
       } else {
         setSortConfig({ key: columnKey, direction: "asc" });
       }
     } else {
       setSortConfig({ key: columnKey, direction: "asc" });
     }
   };
 
   const getSortIcon = (columnKey) => {
     const column = columns1.find((col) => col.key === columnKey);
     if (!column?.sortable) return null;
 
     const isActive = sortConfig.key === columnKey;
     const direction = sortConfig.direction;
     let iconClass = "fa-solid ";
 
     if (!isActive) iconClass += "fa-sort";
     else if (direction === "asc") iconClass += "fa-arrow-up";
     else if (direction === "desc") iconClass += "fa-arrow-down";
 
     return (
       <i
         className={iconClass}
         style={{
           opacity: isActive && direction ? 1 : 0.3,
           transition: "opacity 0.3s ease",
           color: isActive ? "#f5751D" : "#aaa",
           marginLeft: "5px",
           fontSize: "12px",
         }}
       ></i>
     );
   };
 
   // Helper function to get duration in seconds for sorting
   const getDurationSeconds = (row) => {
     const duration = timeDifference[row.id];
     if (!duration) return 0;
 
     // For DIALING status, return 0
     if (row.Status === "DIALING") return 0;
 
     return duration.totalSeconds || 0;
   };
 
   const sortedData = useMemo(() => {
     if (!sortConfig.key) return mockDataTeam;
 
     const dir = sortConfig.direction === "asc" ? 1 : -1;
 
     return [...mockDataTeam].sort((a, b) => {
       // Special handling for CallDuration sorting
       if (sortConfig.key === "CallDuration") {
         const aSeconds = getDurationSeconds(a);
         const bSeconds = getDurationSeconds(b);
         return (aSeconds - bSeconds) * dir;
       }
 
       // Handle date sorting
       if (sortConfig.key === "DateStamp" || sortConfig.key === "TimeStamp") {
         const aTime = new Date(a.TimeStamp).getTime();
         const bTime = new Date(b.TimeStamp).getTime();
         return (aTime - bTime) * dir;
       }
 
       // Handle string sorting for other columns
       let av = a[sortConfig.key];
       let bv = b[sortConfig.key];
 
       av = String(av ?? "").toLowerCase();
       bv = String(bv ?? "").toLowerCase();
 
       if (av < bv) return -1 * dir;
       if (av > bv) return 1 * dir;
       return 0;
     });
   }, [mockDataTeam, sortConfig, timeDifference]);
 

  if (user?.blocked_features?.includes("live_call_hangup")) {
    allColumns.push({
      field: "hangup",
      headerName: "Hangup",
      headerClassName: "custom-header",
      flex: 1,
      minWidth: 70,
      headerAlign: "left",
      disableColumnMenu: true,
      sortable: false,
      align: "left",
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-between align-items-center">
            {params.row.Status === "BUYER_ANSWERED" && (
              <Button
                sx={{
                  ":hover": { bgcolor: "error.main", color: "white" },
                  padding: "2px",
                  textTransform: "capitalize",
                  fontSize: "14px",
                  color: "error.main",
                  borderColor: "error.main",
                  border: "1px solid #d32f2f",
                }}
                onClick={() => handleHangup(params.row)}
              >
                <PhoneDisabledIcon />
              </Button>
            )}
          </div>
        );
      },
    });
  }

  // Mobile view columns
  
  const mobileColumns = allColumns.filter((col) =>
    [
      "DIDNumber",
      "CallerID",
      "ForwardedTo",
      "Status",
      "CallDuration",
      "hangup",
    ].includes(col.field),
  );

  // Table columns based on device
  const columns = isMobile ? mobileColumns : allColumns;

  return (
    <>
      <div className={`App ${userThem} `}>
        <div className="contant_box">
          <div className="main">
            <section className="sidebar-sec">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="">
                      <div className="tab-content" id="pills-tabContent">
                        <div
                          className="tab-pane fade show active"
                          id="pills-home"
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                        >
                          <div className="tab_cntnt_box ">
                            <div
                              className="cntnt_title"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <div>
                                <PageTitle title="Active Calls" />
                              </div>
                            </div>

                            <div className="table-wrapper">
                              <div className="scroll-top">
                                <div
                                  className="scroll-inner"
                                  style={{ width: "100%", overflowX: "auto" }}
                                >
                                  <Table
                                    hover
                                    size="sm"
                                    bordered
                                    className="call-active-table border-1 table-striped"
                                    style={{ minWidth: "1100px" }} // 👈 important for horizontal scroll
                                  >
                                    <tr className="active-table-head">
                                      {columns1.map((col) => (
                                        <th
                                          key={col.key}
                                          onClick={() => handleSort(col.key)}
                                          style={{
                                            cursor: col.sortable
                                              ? "pointer"
                                              : "default",
                                            userSelect: "none",
                                            textAlign: col.textAlign || "left",
                                            position: "relative",
                                          }}
                                        >
                                          <span>{col.label}</span>
                                          <span className="sortingicon">
                                            {getSortIcon(col.key)}
                                          </span>
                                        </th>
                                      ))}
                                    </tr>

                                    <tbody>
                                      {sortedData.length === 0 ? (
                                        <tr>
                                          <td
                                            colSpan={columns1.length}
                                            className="text-center text-muted"
                                          >
                                            No active calls found
                                          </td>
                                        </tr>
                                      ) : (
                                        sortedData.map((row, index) => {
                                          const duration =
                                            timeDifference[row.id];
                                          const date = new Date(row.TimeStamp);
                                          const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(
                                            date.getMonth() + 1,
                                          ).padStart(
                                            2,
                                            "0",
                                          )}/${date.getFullYear()}`;
                                          const formattedTime = `${String(date.getHours()).padStart(2, "0")}:${String(
                                            date.getMinutes(),
                                          ).padStart(
                                            2,
                                            "0",
                                          )}:${String(date.getSeconds()).padStart(2, "0")}`;

                                          return (
                                            <tr key={row.id}>
                                              <td className="text-center">
                                                {index + 1}
                                              </td>
                                              <td>{row.DIDNumber || "-"}</td>
                                              <td>{row.CallerID || "-"}</td>
                                              <td>{row.CompaignName || "-"}</td>                                              
                                              <td>{row.BuyerName || "-"}</td>
                                              <td>{row.ForwardedTo || "-"}</td>
                                              <td>
                                                <span
                                                  style={{
                                                    color:
                                                      row.Status === "ANSWER" ||
                                                      row.Status ===
                                                        "BUYER_ANSWERED"
                                                        ? "green"
                                                        : row.Status ===
                                                            "RINGING"
                                                          ? "skyblue"
                                                          : row.Status ===
                                                              "DIALING"
                                                            ? "violet"
                                                            : "grey",
                                                    fontWeight: 500,
                                                  }}
                                                >
                                                  {row.Status || "-"}
                                                </span>
                                              </td>
                                              <td
                                                style={{
                                                  color:
                                                    row.Status === "DIALING"
                                                      ? "grey"
                                                      : "green",
                                                  textAlign: "center",
                                                  fontWeight: 600,
                                                }}
                                              >
                                                {duration &&
                                                row.Status !== "DIALING"
                                                  ? `${duration.hours}:${duration.minutes}:${duration.seconds}`
                                                  : "00:00:00"}
                                              </td>
                                              <td>
                                                <span style={{ color: "blue" }}>
                                                  {formattedDate}
                                                </span>
                                                 <span
                                                  style={{ color: "green", marginLeft: "5px", }}
                                                >
                                                  {formattedTime}
                                                </span>
                                              </td>
                                              

                                              <td className="text-center">
                                                {row.Status ===
                                                  "BUYER_ANSWERED" && (
                                                  <Button
                                                    size="sm"
                                                    variant="outline-danger"
                                                    onClick={() =>
                                                      handleHangup(row)
                                                    }
                                                    style={{
                                                      padding: "2px 8px",
                                                      borderColor: "#dc3545",
                                                      color: "#dc3545",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                      e.target.style.backgroundColor =
                                                        "#dc3545";
                                                      e.target.style.color =
                                                        "white";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                      e.target.style.backgroundColor =
                                                        "transparent";
                                                      e.target.style.color =
                                                        "#dc3545";
                                                    }}
                                                  >
                                                    <PhoneDisabledIcon fontSize="small" />
                                                  </Button>
                                                )}
                                              </td>
                                            </tr>
                                          );
                                        })
                                      )}
                                    </tbody>
                                  </Table>
                                </div>
                              </div>
                            </div>

                            {/* <ThemeProvider theme={theme}>
                              <div style={{ height: "100%", width: "100%" }}>
                                <StyledDataGrid
                                   sx={{ "& .even-row": {
                                          backgroundColor: "#f9f9f9",
                                        },
                                        "& .odd-row": {
                                          backgroundColor: "#ffffff",
                                        },
                                      }}
                                      
                                    rows={mockDataTeam}
                                    columns={columns}
                                    density="compact"
                                    headerClassName="custom-header"
                                    components={{ Toolbar: GridToolbar }}
                                    slots={{
                                      toolbar: CustomToolbar,
                                      footer: CustomFooterStatusComponent,
                                    }}
                                    autoHeight
                                    getRowId={(row) => row.id}
                                    getRowClassName={(params) =>
                                      params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"
                                    }
                                    initialState={{
                                      sorting: {
                                        sortModel: [{ field: "TimeStamp", sort: "desc" }],
                                      },
                                    }}
                                  />

                                
                              </div>
                            </ThemeProvider> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default CallActive;